document.addEventListener('DOMContentLoaded', function() {
  const yardageInput = document.querySelector('[data-yardage-input]');
  const originalQtyInput = document.querySelector('[data-original-qty]');
  const yardageWrapper = document.querySelector('.yardage-qty__wrapper');
  const minusButton = document.querySelector('.yardage-qty__adjust--minus');
  const plusButton = document.querySelector('.yardage-qty__adjust--plus');

  if (!yardageInput || !originalQtyInput) {
    console.warn('Yardage inputs not found');
    return;
  }

  function updateYardageValues() {
    const yardageValue = parseFloat(yardageInput.value);
    const cartQuantity = Math.round(yardageValue * 4);
    
    originalQtyInput.value = cartQuantity;
    
    const changeEvent = new Event('change', { bubbles: true });
    originalQtyInput.dispatchEvent(changeEvent);
    
    updateYardageLabel(yardageValue);
  }

  function updateYardageLabel(value) {
    const labelElement = document.querySelector('.yardage-qty__label');
    if (!labelElement) return;
    
    const singularLabel = labelElement.getAttribute('data-label');
    const pluralLabel = labelElement.getAttribute('data-label-plural');
    
    if (value === 1) {
      labelElement.textContent = singularLabel;
    } else {
      labelElement.textContent = pluralLabel;
    }
  }

  function handleInputChange() {
    let value = parseFloat(yardageInput.value);
    
    if (isNaN(value) || value < 0.25) {
      value = 0.25;
      yardageInput.value = value;
    }
    
    value = Math.round(value * 4) / 4;
    yardageInput.value = value;
    
    updateYardageValues();
  }

  function handleMinus() {
    let currentValue = parseFloat(yardageInput.value);
    let newValue = currentValue - 0.25;
    
    if (newValue < 0.25) {
      newValue = 0.25;
    }
    
    yardageInput.value = newValue;
    updateYardageValues();
    
    yardageWrapper.classList.add('is-loading');
    setTimeout(() => yardageWrapper.classList.remove('is-loading'), 150);
  }

  function handlePlus() {
    let currentValue = parseFloat(yardageInput.value);
    let newValue = currentValue + 0.25;
    
    yardageInput.value = newValue;
    updateYardageValues();
    
    yardageWrapper.classList.add('is-loading');
    setTimeout(() => yardageWrapper.classList.remove('is-loading'), 150);
  }

  yardageInput.addEventListener('input', handleInputChange);
  yardageInput.addEventListener('blur', handleInputChange);
  
  if (minusButton) {
    minusButton.addEventListener('click', handleMinus);
  }
  
  if (plusButton) {
    plusButton.addEventListener('click', handlePlus);
  }

  yardageInput.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      if (e.key === 'ArrowUp') {
        handlePlus();
      } else {
        handleMinus();
      }
    }
  });

  updateYardageValues();

  document.addEventListener('variant:change', function() {
    updateYardageValues();
  });
});
